const EXTENSION_MIME_TYPES: Record<string, string> = {
  pdf: "application/pdf",
  png: "image/png",
  jpg: "image/jpeg",
  jpeg: "image/jpeg",
  gif: "image/gif",
  webp: "image/webp",
  svg: "image/svg+xml",
  txt: "text/plain",
  md: "text/markdown",
  markdown: "text/markdown",
  csv: "text/csv",
  doc: "application/msword",
  docx: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  xls: "application/vnd.ms-excel",
  xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  xltm: "application/vnd.ms-excel.template.macroEnabled.12",
  ppt: "application/vnd.ms-powerpoint",
  pptx: "application/vnd.openxmlformats-officedocument.presentationml.presentation"
};

/**
 * Infer a MIME type from a filename extension when the browser/OS left
 * `File.type` empty (common for Windows drag-and-drop of Office files).
 * @param fileName - Filename used to look up the extension.
 * @returns The inferred MIME type, or undefined when the extension is unknown.
 */
export function inferMimeTypeFromFileName(fileName: string): string | undefined {
  const extension = fileName.split(".").pop()?.toLowerCase();
  if (!extension || extension === fileName.toLowerCase()) return undefined;
  return EXTENSION_MIME_TYPES[extension];
}

/**
 * Return the same file, or a copy with an inferred MIME type when `type` is empty.
 * @param file - Browser File that may have an empty MIME type.
 * @returns The original file, or a copy with an inferred MIME type.
 */
export function withInferredMimeType(file: File): File {
  if (file.type) return file;
  const mimeType = inferMimeTypeFromFileName(file.name);
  if (!mimeType) return file;
  return new File([file], file.name, {
    type: mimeType,
    lastModified: file.lastModified
  });
}
